module.exports = __webpack_public_path__ + "static/media/1b0de2e2-92ee-4a99-a639-dcefd7fd8c0b_1.4f1d463ea02c79d82df4e505fd3c8800.98764a09.jpeg";